module.exports = __webpack_public_path__ + "static/img/clarke-cooper.c4dc5a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clarke-cooper.jpg
// module id = xL8I
// module chunks = 0